// src/pages/TitleAndTag.jsx
import React, { useState, useRef, useEffect } from "react";
import "./TitleAndTag.css";
import { Filter } from "bad-words";
import { useNavigate } from "react-router-dom";
import BottomNav from "./BottomNav";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { FaArrowLeft } from "react-icons/fa";

const sectors = [
  "Technology", "Health", "Education", "Business", "Lifestyle",
  "Media", "Environment", "Society", "Mobility", "Infrastructure", "Arts", "Sports"
];

const TitleAndTag = () => {
  const filter = new Filter();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [showTags, setShowTags] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const tagListRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [error, setError] = useState("");
  const [uid, setUid] = useState(null);

  const auth = getAuth();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => setUid(user ? user.uid : null));
    return unsub;
  }, []);

  const isFormValid =
    title.trim() !== "" &&
    selectedTags.length > 0 &&
    title.length <= 100 &&
    !filter.isProfane(title);

  const showPopupMessage = (message) => {
    setPopupMessage(message);
    setShowPopup(false);
    setTimeout(() => {
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2500);
    }, 10);
  };

  const handleContinue = async () => {
    const charLimit = 250;
    if (!title.trim()) return showPopupMessage("Title cannot be empty.");
    if (title.length > charLimit) return showPopupMessage(`Title should not exceed ${charLimit} characters.`);
    if (selectedTags.length === 0) return showPopupMessage("Please select at least one tag.");
    if (!uid) return showPopupMessage("Please sign in to continue.");

    setIsLoading(true);
    navigate("/Description", { state: { title, tags: selectedTags } });
  };

  const toggleTag = (tag, isDisabled) => {
    if (isDisabled) {
      showPopupMessage("You can only select up to 2 tags.");
      return;
    }
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tagListRef.current && !tagListRef.current.contains(e.target)) {
        setShowTags(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div className="post-form-page">
        <header className="post-header">
          <button
            type="button"
            className="post-back-btn"
            aria-label="Go back"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft />
          </button>
          <h1 className="post-page-title">Title &amp; Tag</h1>
        </header>

        <main className="post-card" ref={tagListRef}>
          <span className="post-pin" aria-hidden="true"></span>

          <div className="post-field">
            <label className="post-field-label" htmlFor="post-title">
              What's your idea?
            </label>
            <input
              id="post-title"
              className="post-input"
              type="text"
              placeholder="e.g. A community tool library for your street"
              value={title}
              maxLength={100}
              onChange={(e) => {
                const text = e.target.value;
                setTitle(text);
                setError(filter.isProfane(text) ? "Inappropriate language is not allowed." : "");
              }}
              required
            />
            {error && <p className="post-field-error">{error}</p>}
            <div className={`post-char-counter ${title.length === 100 ? "post-limit-exceeded" : ""}`}>
              {title.length} / 100
            </div>
          </div>

          <div className="post-field">
            <label className="post-field-label" id="post-tags-label">
              Pick up to 2 categories
            </label>

            <div
              className="post-tag-dropdown"
              role="button"
              tabIndex={0}
              aria-expanded={showTags}
              aria-labelledby="post-tags-label"
              onClick={() => setShowTags(!showTags)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setShowTags(!showTags)}
            >
              <span className={selectedTags.length === 0 ? "post-placeholder" : ""}>
                {selectedTags.length === 0 ? "Add tags" : selectedTags.join(", ")}
              </span>
              <span className="post-arrow">{showTags ? "▲" : "▼"}</span>
            </div>

            <div className={`post-tag-list-wrap ${showTags ? "open" : ""}`}>
              <div className="post-tag-list">
                {sectors.map((sector) => {
                  const isChecked = selectedTags.includes(sector);
                  const isDisabled = !isChecked && selectedTags.length >= 2;
                  return (
                    <label key={sector} className={`post-tag-chip ${isDisabled ? "is-disabled" : ""}`}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        disabled={isDisabled}
                        onClick={() => toggleTag(sector, isDisabled)}
                        readOnly
                      />
                      <span className="post-tag-chip-stamp" aria-hidden="true"></span>
                      {sector}
                    </label>
                  );
                })}
              </div>
            </div>
          </div>

          <button
            className="post-continue-btn"
            disabled={!isFormValid || isLoading}
            onClick={handleContinue}
          >
            {isLoading ? <span className="post-loader"></span> : "Continue"}
          </button>
        </main>

        {showPopup && <div className="post-popup">{popupMessage}</div>}
      </div>
      <BottomNav />
    </>
  );
};

export default TitleAndTag;